import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const ThumbsDown = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="thumbs down icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M8.40434 14.595L13.663 21.554C13.8752 21.8349 14.2069 22 14.559 22C15.2904 22 15.8267 21.3119 15.648 20.6026L14.3114 15.2961C14.1529 14.667 14.6261 14.0559 15.2748 14.0518L19.5262 14.025C21.5183 14.0125 22.9451 12.0975 22.3873 10.1851L20.42 3.44C20.1711 2.58667 19.3889 2 18.5 2H10C8.89543 2 8 2.89543 8 4V13.3892C8 13.8244 8.14196 14.2477 8.40434 14.595Z"
    />
    <path
      className={pathClass}
      d="M3 14C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H5C5.55228 2 6 2.44772 6 3V13C6 13.5523 5.55228 14 5 14H3Z"
    />
  </svg>
)
